<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">
        <div class="text-sm-start d-none d-sm-block">
          {{version}} &nbsp;|&nbsp; All displayed times are in UTC
        </div>
      </div>
      <div class="col-sm-6">
        <div class="text-sm-end d-none d-sm-block">
          &copy; {{year}} {{ourCompanyName}}
        </div>
      </div>
    </div>
  </div>
</footer>
